import { transform } from './mapper.js'

const questionField = [
  {
    text: 'Were vitals reported by patient?',
    key: 'reportedByPatient'
  },
  {
    text: 'Were vitals obtained via medical record?',
    key: 'obtainedViaMedRec'
  }
]

const transformQuestions = data => {
  const vitalsPanel = data.entry.find(entry => entry.resource.contained)
  return vitalsPanel.resource.contained[0].item.reduce((acc, item) => {
    const field = questionField.find(fld => fld.text === item.text)
    return {
      ...acc,
      [field.key]: item.answer[0].valueString
    }
  }, {})
}

const loincCode = (code, display) => ({
  coding: [
    {
      system: 'http://loinc.org',
      code,
      display
    }
  ],
  text: display
})

const observation = (code, display, units) => [
  'entry',
  {
    resource: {
      resourceType: 'Observation',
      code: loincCode(code, display),
      valueQuantity: {
        unit: units || 'unknown',
        system: 'http://unitsofmeasure.org'
      }
    }
  },
  'resource',
  'valueQuantity',
  'value'
]

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'Bundle'
  },
  {
    fhir: observation('59408-5', 'Body Temperature', '°F'),
    form: [ 'temperature' ]
  },
  {
    fhir: observation('29463-7', 'Body Weight', 'lbs.'),
    form: [ 'weight' ]
  },
  {
    fhir: observation('39156-5', 'Body mass index (BMI) [Ratio]', 'kg/m²'),
    form: [ 'bmi' ]
  },
  {
    fhir: observation('9279-1', 'Respiratory Rate', 'breaths per minute'),
    form: [ 'respiratoryRate' ]
  },
  {
    fhir: observation('8867-4', 'Heart Rate', 'beats per minute'),
    form: [ 'pulse' ]
  },
  {
    fhir: observation(
      '549408-5',
      'Oxygen saturation in Arterial blood by Pulse oximetry',
      '%'
    ),
    form: [ 'pulseOxygen' ]
  },
  {
    fhir: observation('8302-2', 'Body height', 'inches'),
    form: [ 'height' ]
  },
  {
    fhir: observation('8462-4', 'Diastolic blood pressure', 'mmHg'),
    form: [ 'diastolic' ]
  },
  {
    fhir: observation('8480-6', 'Systolic blood pressure', 'mmHg'),
    form: [ 'systolic' ]
  }
]

const clone = x => JSON.parse(JSON.stringify(x))

export const mapVitals = form => {
  const bundle = transform(form, clone(mapping), [ 'form', 'fhir' ])
  bundle.entry?.forEach(e => {
    e.resource.status = 'registered'
  })
  return bundle
}

export const unmapVitals = data => {
  const questionFields = transformQuestions(data) || {}
  const otherField = transform(data, clone(mapping), [ 'fhir', 'form' ])
  return {
    ...otherField,
    ...questionFields
  }
}
